import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { getCoreAxiosInstance } from "../../api/CoreAxiosInstance";
import { CompanyElementMappingSchema } from "../types";

/**
 * Retrieve existing element→column mappings for a company.
 *
 * GET /api/v1/christmas/companies/{companyCode}/pay-components/mappings
 *
 * Returns CompanyElementMapping[] — the persisted column mappings for the
 * company's pay element parameters.
 */
export function useCompanyMappings(companyCode: string) {
  return useQuery({
    queryKey: ["pay-component-import", "mappings", companyCode],
    queryFn: async () => {
      const instance = await getCoreAxiosInstance();
      const { data } = await instance.get(
        `/api/v1/christmas/companies/${companyCode}/pay-components/mappings`,
      );
      return z.array(CompanyElementMappingSchema).parse(data);
    },
    enabled: !!companyCode,
  });
}
